import React from "react";
import "./DeliverySummary.css";
import { DeliveryInvoiceSummary } from "../../types/types";

interface DeliverySummaryProps {
  invoiceSummary: DeliveryInvoiceSummary;
}
interface SummaryBox {
  label: string
  value: number
  backgroundColor: string
  valueColor: string
}

const DeliverySummary: React.FC<DeliverySummaryProps> = ({ invoiceSummary }) => {

  const summaryStructure: SummaryBox[] = [
    {
      label:"Total Invoices",
      value:invoiceSummary.total,
      backgroundColor:"#ecf0ff",
      valueColor:"#1843cf"
    },
    {
      label:"Delivered Invoices",
      value:invoiceSummary.delivered,
      backgroundColor:"#e9fff5",
      valueColor:"#179544"
    },
    {
      label:"Partially Delivered Invoices",
      value:invoiceSummary.partiallyDelivered,
      backgroundColor:"#f0fbff",
      valueColor:"#1bb4a2"
    },
    {
      label:"Pending Invoices",
      value:invoiceSummary.pending,
      backgroundColor:"#fef8ef",
      valueColor:"#d08e20"
    },
    {
      label:"Cancelled Invoices",
      value:invoiceSummary.cancelled,
      backgroundColor:"#fefaf7",
      valueColor:"#c84d26"
    }
  ]

  return (
    <div className="delivery-summary-container">
      <div className="delivery-summary-left">
        <div className="delivery-summary-label">Delivery Summary</div>
      </div>
      <div className="delivery-summary-right">
        {summaryStructure.map((summaryObject:SummaryBox, index:number)=>(
          <>
            <div className="summary-box" style={{ backgroundColor: summaryObject.backgroundColor }}>
              <div className="summary-box-label">{summaryObject.label}</div>
              <div className="summary-box-value" style={{ color: summaryObject.valueColor }}>{summaryObject.value}</div>
            </div>
            {index<summaryStructure.length-1 ?<div className="delivery_summary_vl"></div> : <></>}
          </>
        ))}
      </div>
    </div>
  );
};

export default DeliverySummary;